import React from 'react';

import { HeroProps } from '../../Hero';

import styles from './HeroContent.scss';

export const HeroContent = ({ subTitle, title }: HeroProps) => (
  <section className={styles.component}>
    <h1 className={styles.title}>{title}</h1>
    <p className={styles.subTitle}>{subTitle}</p>
  </section>
);
